<template>
  <div class="contents">
    <div class="warn-block">
      <div id="DrivingReductionChart"></div>
    </div>
  </div>
</template>
<script>
import Http from "../../../Serves/net-http.js";
import Api from "../../../Serves/net-api.js";
export default {
  name: 'DrivingReduction',
  components: {
    
  },
  props: ["search"],
  watch: {
    search(curVal, oldVal) {
      console.log(curVal)
    }
  },
  data() {
    return {
      DrivingReductionchars: ''
    }
  },
  mounted() {
    setTimeout(() => {
      // 监听省份变化
      this.bus.$on('search3',res=>{
        console.log(res.search,'search3')
        var parmse = {
          countyCode: res.search.countyCode,
          machineType: res.search.machineType,
          type: 4
        }
        Api.doPost(Http.homePageStatis.findEmissionReductionByRegion, parmse, false, res => {
          this.DrivingReductiongetdatas(res.result.roadEmissionList)
        })
      })
    })
    this.findEmissionReductionByRegion()
    // this.inits()
    this.DrivingReductioninits()
  },
  methods: {
    DrivingReductioninits() {
      setTimeout(() => {
        window.addEventListener("resize", () => {
          this.DrivingReductionchars.resize()
        })
      }, 30)
    },
    findEmissionReductionByRegion () {
      var parmse = {
        countyCode: this.search.countyCode,
        machineType: this.search.machineType,
        type: 4
      }
      Api.doPost(Http.homePageStatis.findEmissionReductionByRegion, parmse, false, res => {
        this.DrivingReductiongetdatas(res.result.roadEmissionList)
      })
    },
    DrivingReductiongetdatas(data) {
      var nameArr = data.map(item => {
        return item.areaName
      })
      var areaArr = data.map(item => {
        return item.roadEmission
      })
      this.DrivingReductionchars = this.$echarts.init(document.getElementById("DrivingReductionChart"));
      this.DrivingReductionchars.setOption({
        tooltip: {
          trigger: "axis",
          formatter: "{b} <br/>行使减排量 : {c}克",
          axisPointer: {
            type: "line",
            label: {
              backgroundColor: "#0B1640"
            }
          }
        },
        // legend: {
        //   // data: ["未上报数据", "作业面积未达标"],
        //   top: 0, // 距离容器上边界40像素
        //   textStyle: {
        //     color: "#ffffff",
        //     fontSize: 14
        //   }
        // },
        grid: {
          top: "7%", // 距离容器上边界40像素
          bottom: "7%", // 距离容器下边界30像素
          left: 90,
          right: 100
        },
        xAxis: [
          {
            type: "category",
            axisLabel: {
              color: "#fff"
            },
            axisLine: {
              lineStyle: {
                color: "#dddddd"
              },
              width: 5
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            data: nameArr
            // data: [
            //   "山东省",
            //   "湖南省",
            //   "上海市",
            //   "北京市",
            //   "天津市",
            //   "福建省",
            //   "湖北省",
            //   "河北省",
            //   "河南省"
            // ]
          }
        ],
        yAxis: [
          {
            type: "value",
            // name: '机具数量（台）',
            nameTextStyle: {
              color: "#a0a0a0"
            },
            axisLabel: {
              show: true,
              color: "#fff"
              //   formatter: '{value} 台'
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#dddddd"
              },
              width: 5
            },
            axisTick: {
              show: false
            },
            splitLine: {
              lineStyle: {
                width: 0.2,
                type: "dashed",
                color: "#e9e9e9"
              }
            }
          }
        ],
        series: [
          {
            name: "行驶减排量",
            type: "line",
            // smooth: true,
            // color: "#0966d9",
            stack: "name",
            // areaStyle: {},
            data: areaArr
            // data: [123, 456, 231, 321, 213, 421, 623, 95, 100]
          }
        ]
      })
    },
  }
};
</script>
<style scoped>
.warn-block{
  width: 100%;
}
#DrivingReductionChart {
  width: 100%;
  height: 67vh;
}
</style>



// WEBPACK FOOTER //
// src/components/MachineryDistribution/ReductionEquipment/DrivingReduction.vue